export default {
  systemTemplate: 'システムテンプレート',
  myTemplate: 'マイテンプレート',
  customCreate: 'カスタム作成',
  newTemplate: '新規テンプレート',
  emptyMyTemplate: 'テンプレートがありません',
};
